import { get } from 'lodash';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';

import { PKR_LOADERS } from '../constants';
import { useHomeGamesWidget } from '../model';

const useInitialLoading = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const loadingState = useSelector(widgetSelect.loading);
  const isLoginLoading = useSelector(
    (rootState: RootState) => !!rootState.loading?.effects.auth.login
  );
  const isRegLoading = useSelector(
    (rootState: RootState) => !!rootState.loading?.effects.auth.register
  );
  const isAuthenticating = isLoginLoading || isRegLoading;
  const loading =
    get(loadingState, PKR_LOADERS.initial) || get(loadingState, PKR_LOADERS.joinPromoClub);

  return loading || isAuthenticating;
};

export default useInitialLoading;
